<template>
  <div>
    <ReducedebtHeader :img_header="header_image" header="ดูรายละเอียดสินค้า" link_back="stock/storage/reducedebt"/>
    <Reduce_debt_details/>
  </div>
</template>

<script>
import ReducedebtHeader from "@/components/admin/stock/storage_reducedebt/header_reducedebt/ReducedebtHeader";
import HeaderImage from "@/assets/loupe.png";
import Reduce_debt_details from "@/components/admin/stock/storage_reducedebt/Reduce_debt_details";
export default {
  name: "ReduceDebtDetails",
  components: {
    Reduce_debt_details,
    ReducedebtHeader,
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>